import React, { useState } from 'react';
import {
  Box,
  Button,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useGlobalContext } from "../../../context/Appcontext";
import groupChatsByDate from '../../../utils/groupChat';
import "./sidebar.css"
// icons
import newChatIcon from "../../../assets/newChat.svg";
import searchIcon from "../../../assets/search.svg";
import expandIcon from "../../../assets/expand.svg";
import SearchPopup from '../../search';

const Sidebar = () => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const {
    chats,
    activeChat,
    setActiveChat,
    isLoading,
    error
  } = useGlobalContext();

  const handleNewChat = () => {
    setActiveChat(null);
  };

  const toggleSearchWindow = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  const toggleSidebar = () => {
    setIsExpanded(!isExpanded);
  };

  const renderChatGroup = (chats:any, title:any) => {
    if (!chats || chats.length === 0) return null;

    return (
      <Box sx={styles.chatGroup}>
        <Typography sx={styles.groupTitle}>{title}</Typography>
        {chats
          .sort((a:any, b:any) => new Date(b.last_updated).getTime() - new Date(a.last_updated).getTime())
          .map((chat:any) => (
            <ListItemButton
              key={chat.session_id}
              onClick={() => setActiveChat(chat.session_id)}
              className={`chat-item ${chat.session_id === activeChat ? "selected" : ""}`}
              sx={styles.chatItem}
            >
              <ListItemText
                primary={chat.messages[0]?.message || chat.messages[0]?.text || "New Chat"}
                primaryTypographyProps={{
                  sx: styles.chatItemText
                }}
              />
            </ListItemButton>
          ))}
      </Box>
    );
  };

  const groupedChats = groupChatsByDate(chats);

  return (
    <>
      <Button 
        variant="contained" 
        sx={{
          ...styles.headerButton,
          position: 'fixed',
          top: '50px',
          left: '30px',
          zIndex: 1000,
        }}
        onClick={toggleSidebar}
      >
        <img 
          src={expandIcon} 
          alt="expand" 
          style={{
            transform: isExpanded ? 'rotate(0deg)' : 'rotate(180deg)',
            transition: 'transform 0.3s ease'
          }}
        />
      </Button>

      <Box sx={{
        ...styles.sidebarStyles,
        transform: isExpanded ? 'translateX(0)' : 'translateX(-105%)',
        transition: 'transform 0.3s ease',
      }}>
        <Box sx={styles.header}>
          <div style={{ width: '40px' }} /> {/* Spacer for expand button */}
          <div>
            <Button 
              variant="contained" 
              sx={styles.headerButton} 
              onClick={toggleSearchWindow}  
            >
              <img src={searchIcon} alt="search"/>
            </Button>
            <Button 
              variant="contained" 
              sx={styles.headerButton} 
              onClick={handleNewChat}
            >
              <img src={newChatIcon} alt="plusIcon"/>
            </Button>
          </div>
        </Box>
        <List sx={styles.chatList} className='chatList'>
          {isLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
              <CircularProgress sx={{ color: '#3878D1' }} />
            </Box>
          ) : error ? (
            <Typography color="error" sx={{ textAlign: 'center', padding: '1rem' }} />
          ) : chats.length > 0 ? (
            <>
              {renderChatGroup(groupedChats.today, "Today")}
              {renderChatGroup(groupedChats.lastWeek, "Previous 7 Days")}
              {renderChatGroup(groupedChats.lastMonth, "Previous 30 Days")}
              {renderChatGroup(groupedChats.older, "Older")}
            </>
          ) : (
            ""
          )}
        </List>
        <SearchPopup
          open={isSearchOpen}
          onClose={toggleSearchWindow}
        />
      </Box>
    </>
  );
};

const styles = {
  sidebarStyles: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: "350px",
    margin: "20px",
    height: "95.6vh",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    zIndex: 999,
    background: "linear-gradient(180deg, #E9F4FD 0%, #F3EBFF 100%)",
    borderRadius: "30px",
  },
  header:{
    display:"flex",
    justifyContent:"flex-end",
    alignItems:"center",
    marginY:"1.2rem"
  },
  title: {
    textAlign: "center",
    marginBottom: "2em",
    fontFamily: "sans-serif",
    fontWeight: "bold",
  },
  chatList: {
    flexGrow: 1,
    overflowY: "auto",
  },
  chatItem: {
    borderRadius: "4px",

    "&:hover": {
      cursor: "pointer",
      borderRadius: "300px",
    },

    "&.selected": {
      borderRadius: "300px",
      background: "#FFF",
      color: "inherit",

      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.2)"
      },
    },
  },
  headerButton: {
    background:"transparent",
    boxShadow: "none",
    "&:hover": {
      background:"transparent",
      boxShadow: "none",
    }
  },
  chatGroup: {
    mb: 2,
  },
  groupTitle: {
    color: '#222',
    fontSize: '16px',
    fontWeight: '700',
    padding: '8px 16px',
    mb: 1,
  },
  chatItemText: {
    color: "#222",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
    mx: "2px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "block",
    width: "100%"
  }
};

export default Sidebar;